import { useEffect, useRef, useState } from "react";
import auth1 from "../assets/pictures/home/auth1.jpg";
import { cls } from "../components/Utility";
import s2 from "../assets/pictures/home/grid2.jpeg";
import s3 from "../assets/pictures/home/grid3.jpeg";
import s4 from "../assets/pictures/home/grid4.jpeg";
import logo from "../assets/logos/RG copy 2.png";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function Authenticity() {
  const images = [auth1, auth1, auth1, auth1, auth1];
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const delay = 3000; // 3 seconds per slide

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, delay);

    return () => resetTimeout();
  }, [currentIndex]);

  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={auth1} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                AUTHENTICITY x ELEGANCE
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={auth1} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                AUTHENTICITY x ELEGANCE
              </h1>
            </div>
          </div>
        </div>
      </div>
      <p className="mt-[30px] mb-[30px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        At Stories by RG, our craft is rooted in authenticity — a commitment to
        capturing real emotions, raw moments, and true love without filters or
        fabrications. Every frame we create is honest, heartfelt, and deeply
        personal. We believe that the most powerful stories are already within
        you; we’re just here to bring them to life with care, creativity, and
        intention.
        <br />
        <br />
        But authenticity is only one side of our craft. The other is elegance —
        a signature style woven through our visuals with finesse and
        sophistication. From the way we compose a shot to how we design the
        final edit, every detail is meticulously curated to reflect beauty,
        grace, and timeless charm. Our films and photographs aren’t just
        memories; they’re heirlooms crafted with an artistic eye and a soulful
        heart.
        <br />
        <br />
        What sets us apart is not just what we deliver, but how we make you feel
        throughout the journey. With in-house experts in photography, video,
        editing, and styling, we ensure that every element — from the lighting
        to the color palette — speaks the language of elegance while staying
        true to who you are. Because for us, every love story deserves to be
        told honestly, and told beautifully.
      </p>
      <div className="pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[40px]">
        <div className="relative w-full h-[500px] overflow-hidden">
          {/* Slides */}
          <div
            className="flex transition-transform duration-1000 ease-linear h-full"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((img, index) => (
              <div key={index} className="w-full h-[500px] flex-shrink-0">
                <img
                  src={img}
                  alt={`Slide ${index}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, idx) => (
              <div
                key={idx}
                className={`w-1 h-1 rounded-full ${
                  currentIndex === idx ? "bg-white" : "bg-gray-500"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mb-[40px]",
          "xl:flex xl:flex-row xl:gap-[40px] xl:justify-center "
        )}
      >
        <img src={s2} className="xl:w-[370px] xl:h-[580px] object-cover" />
        <img src={s3} className="xl:w-[370px] xl:h-[580px] object-cover" />
        <img src={s4} className="xl:w-[370px] xl:h-[580px] object-cover" />
      </div>

      <p
        className={cls(
          "pl-[20px] pr-[20px] text-[14px] font-[description1] text-center",
          "xl:pl-[380px] xl:pr-[380px]"
        )}
      >
        We craft timeless stories that bring every couple’s dreams to life,
        turning moments into unforgettable memories. With passion and precision,
        we capture the magic that makes your love uniquely yours.
      </p>
      <div className="flex justify-center mb-[10px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
